import React, { useEffect, useState } from "react";
import { fetchAPI } from "../utils/api";
import { Form } from "./form/Form";
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { getDatesBetweenDates, getDateWithDayEN } from "../utils/Utils";
import { useDispatch } from "react-redux";
import { hiddenLoader } from "../stores/loading";


export default function Business() {
    const dispatch = useDispatch();
    const [operators, setOperators] = useState([] as any);
    const [options, setOptions] = useState({} as any);
    const [data, setData] = useState({} as any);

    useEffect(() => {
        fetchAPI("/operators")
            .then((res) => res.json())
            .then(setOperators);
    }, []);

    function search(form: any, page: number = 0) {
        setOptions({});
        setData({});
        let firstDate = new Date('1 ' + form.month + ' ' + form.year).toISOString()
        let lastDate = new Date(form.year[0], new Date(firstDate).getMonth() + 1, 1).toISOString()
        form = { ...form, start_date: firstDate.split('T')[0], thru_date: lastDate.split('T')[0] }
        const newDates = getDatesBetweenDates(new Date(firstDate), new Date(lastDate)).map((v: any) => getDateWithDayEN(v))

        fetchAPI(`/commissions/totals?${new URLSearchParams(form)}`)
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    return res.json()
                }
                dispatch(hiddenLoader());
                return res;
            })
            .then((result) => {
                dispatch(hiddenLoader());
                createGraph(result, newDates)
            })
    }

    function reset() {
        setOptions({});
        setData({});
    }

    function createGraph(result: any, newDates: any[]) {
        let data = {}
        let graphData = [] as any;
        const options = {
            responsive: true,
            redraw: true,
            aspectRatio: 4,
            plugins: {
                legend: {
                    position: 'top' as const,
                },
                title: {
                    display: false
                },
            },
        };

        newDates.forEach((key: any) => {
            graphData.push({
                date: key,
                REFUND: result[key]?.REFUND ? result[key].REFUND : 0,
                PAYMENT: result[key]?.PAYMENT ? result[key].PAYMENT : 0
            });
        })

        data = {
            labels: graphData.map((v: any) => v.date),
            datasets: [
                {
                    label: 'PAYMENT',
                    data: graphData.map((v: any) => v.PAYMENT),
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                },
                {
                    label: 'REFUND',
                    data: graphData.map((v: any) => v.REFUND),
                    borderColor: 'rgb(53, 162, 235)',
                    backgroundColor: 'rgba(53, 162, 235, 0.5)',
                },
            ],
        };

        ChartJS.register(
            CategoryScale,
            LinearScale,
            PointElement,
            LineElement,
            Title,
            Tooltip,
            Legend
        );

        setOptions(options);
        setData(data);

    }

    let form = {
        "month": {
            type: 'select', value: ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"]
        },
        "year": {
            type: 'select', value: [2018, 2019, 2020, 2021, 2022, 2023, 2024]
        },

        "operator": {
            type: 'select', value: operators.length > 0 ? operators.map((v: any) => v.name) : []
        },
    }

    return (<>
        <div className="vtmn-p-4">
            <Form
                form={form}
                search={(form: any, page: number) => search(form)}
                reset={() => reset()}
            />
        </div>
        {Object.keys(options).length > 0 && Object.keys(data).length > 0 && data && data.labels.length === data.datasets[0].data.length && <Line options={options} data={data} />}
        <div className="vtmn-flex vtmn-justify-center vtmn-items-center">
            {data && data.datasets && data.datasets.map((data: any) => {
                return <div className="block vtmn-m-5" style={{ width: '300px' }}>
                    <div className="vtmn-card vtmn-card_variant--top-image vtmn-items-center vtmn-overflow-hidden" style={{ width: '70%', height: '70%', margin: 'auto' }}>
                        {`${data.label} : ${data.data.reduce((a: any, b: any) => a + b, 0)}`}
                    </div>
                </div>
            })}
        </div>
    </>
    )
}